export default {
    Menu: 'Menu',
    Add: 'Toevoegen',
    Modify: 'Bewerken',
    Delete: 'Verwijderen',
    Scale: 'Formaat wijzigen',
    Color: 'Kleur',
    Materials: 'Materialen',
    Mesh: 'Mesh',
    Size: 'Grootte',
    Details: 'Details',
    Quantity: 'Aantal',
    AddToCart: 'In winkelwagen',
    AddToCartTitle: 'In winkelwagen',
    Cart: 'Winkelwagen',
    Total: 'Totaal',
    Subtotal: 'Subtotaal',
    Shipping: 'Verzending',
    Shape: 'Vorm',
    PickShape: 'Kies een vorm om aan het canvas toe te voegen',
    ShapeAdded: 'Vorm toegevoegd. Klik op een andere om te vervangen.',
    Clipart: 'Illustratie',
    PickClipart: 'Kies een illustratie om aan het canvas toe te voegen',
    ClipartAdded: 'Illustratie toegevoegd. Klik op een andere om te vervangen.',
    SearchClipart: 'Een illustratie zoeken…',
    NoClipartFound: 'Geen illustratie gevonden',
    Cliparts: 'Clipart',
    Illustration: 'Illustratie',
    AiImage: 'AI-afbeelding',
    AiImageIntro: 'Beschrijf wat je wilt, kies een formaat en krijg 2 voorstellen.',
    AiImageFormat: 'Formaat',
    AiFormatSquare: 'Vierkant',
    AiFormatPortrait: 'Staand',
    AiFormatLandscape: 'Liggend',
    AiImagePlaceholder: 'Bijv.: een gestileerde rode vos, platte stijl, transparante achtergrond…',
    AiGenerate: 'Genereren',
    AiGenerating: 'Genereren…',
    AiPickResult: 'Kies een voorstel',
    AiImageAdded: 'Afbeelding toegevoegd aan het canvas',
    AiImageError: 'Genereren van afbeelding mislukt',
    AiNoResult: 'Geen afbeelding gegenereerd',
    AiImageNotInPlan: 'AI-afbeeldingen genereren zit niet in je abonnement. Activeer de optie om het te gebruiken.',
    SearchIllustration: 'Een illustratie zoeken…',
    NoIllustrationFound: 'Geen illustratie gevonden',
    IllustrationIntro: 'Zoek vectorillustraties om aan het canvas toe te voegen.',
    IllustrationError: 'Zoeken naar illustraties mislukt',
    IllustrationNotVector: 'Dit resultaat is geen bruikbare vector',
    Texts: 'Teksten',
    Images: 'Afbeeldingen',
    Colors: 'Kleuren',
    ThemeEditDesc: 'Bewerk de teksten, afbeeldingen en kleuren van het thema.',
    ThemeNotFound: 'Thema niet gevonden.',
    ThemeNoEditable: 'Dit thema bevat geen bewerkbare elementen.',
    Helpers: 'Linialen, hulplijnen en raster',
    Rulers: 'Linialen',
    RulersHint: 'Schaal in pixels',
    Guides: 'Hulplijnen',
    GuidesHint: 'Markeringen op 25 / 50 / 75 %',
    GridHint: 'Raster als overlay',
    Snapping: 'Uitlijnen',
    SnappingHint: 'Lijnt uit op midden / raster / andere objecten',
    LeaveConfirm: 'Weet je zeker dat je je wijzigingen wilt verliezen?',
    Products: 'Producten',
    Customization: 'Personalisatie',
    BackToCustomizationType: 'Type personalisatie',
    SaveNoChanges: 'Geen wijzigingen om op te slaan',
    ChooseCategory: 'Kies een categorie',
    SelectProduct: 'Kies een product',
    Loading: 'Laden',
    ProofLogoTooLarge: 'Logo te groot (maximaal 500 KB).',
    ProofLogoInvalidType: 'Niet-ondersteund afbeeldingsformaat.',
    ProofLogoImported: 'Logo geïmporteerd.',
    ProofLogoImportFailed: 'Importeren van logo mislukt.',
    YouHaveProjects: 'Je hebt {count} lopend(e) project(en)',
    ResumeProject: 'Een project hervatten',
    ResumeProjectHint: 'Ga verder waar je gebleven was.',
    YourProjects: 'Je lopende projecten',
    OpenProject: 'Dit project openen',
    NoProjects: 'Geen lopende projecten.',
    AppUpdating: 'De applicatie wordt bijgewerkt…',
    DraftRestored: 'Concept hersteld',
    SaveExpiredTitle: 'Opslag verlopen',
    SaveExpiredMessage: 'Deze opslag is verlopen of niet meer beschikbaar.',
    Continue: 'Doorgaan',
    PhotoFramePickShape: 'Kies een kader',
    PhotoFramePlacePhoto: 'Plaats en pas je foto aan',
    PhotoFrameChangePhoto: 'Foto wijzigen',
    PhotoFrameDropTitle: 'Sleep hier een foto',
    PhotoFrameDropSub: 'of klik om te uploaden',
    Rotation: 'Rotatie',
    Reset: 'Opnieuw instellen',
    ProofLogoTitle: 'Logo van de drukproef',
    ProofLogoUseSite: 'Logo van {site} behouden',
    ProofLogoUseMine: 'Met mijn eigen logo',
    ProofLogoUseMineDesc: 'Alleen op de drukproef, niet op de afdrukbestanden.',
    ProofLogoNone: 'Zonder logo',
    ProofLogoDropTitle: 'Upload je logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Je bestelling wordt gevalideerd',
    LoadingStepScreenshots: 'Voorbeelden genereren',
    LoadingStepPrintFile: 'Afdrukbestanden genereren',
    LoadingStepUpload: 'Uploaden naar server',
    LoadingStepSave: 'Configuratie opslaan',
    LoadingGraduation: 'Schaalverdeling laden',
    OptimizingImage: 'Afbeelding optimaliseren',
    LoadingScene: 'Scène laden',
    LoadingStepZip: 'Zip aanmaken',
    LoadingProduct: 'Product laden',
    Category: 'Categorie',
    Product: 'Product',
    Summary: 'Overzicht',
    Zone: 'Zone',
    SelectZone: 'Een zone selecteren',
    SelectAZone: 'Een zone kiezen',
    Undo: 'Ongedaan maken',
    Redo: 'Opnieuw',
    Recenter: 'Weergave centreren',
    HelpersIntro: 'Zoneranden, raster, linialen en hulplijnen op het 2D-canvas.',
    ShowZoneBordersHint: 'Zonekaders op het hoofdcanvas',
    Save: 'Opslaan',
    Saving: 'Opslaan',
    Grid: 'Raster',
    SwitchTo3D: 'Naar 3D schakelen',
    PrintZone: 'Afdrukzone',
    ViewModeSwitch: 'Weergavemodus',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Dubbel',
    ShowZoneBorders: 'Zoneranden tonen',
    ShowZoneBordersHelp: 'Toont/verbergt de stippellijn en het label van de zones op het 2D-canvas.',
    ManageElements: 'Elementen beheren',
    StartWithTheme: 'Beginnen met een thema',
    Customize: 'Personaliseren',
    FromThemeLibrary: 'Uit onze themabibliotheek',
    StartFromScratch: 'Vanaf nul beginnen',
    Or: 'of',
    PreviousCreations: 'Eerdere creaties',
    WithModel: 'Met een sjabloon',
    Search: 'Zoeken',
    SubCategory: 'Subcategorie',
    Next: 'Volgende',
    Previous: 'Vorige',
    Validate: 'Bevestigen',
    DownloadMyProject: 'Mijn project downloaden',
    EditThemeColors: 'Kleuren van de elementen bewerken',
    AddPattern: 'Een achtergrond toevoegen',
    EditGraduation: 'Verloop bewerken',
    Pattern: 'Achtergrond',
    PatternHint: 'Het patroon wordt herhaald over het hele personalisatiegebied. De kleuren zijn aanpasbaar.',
    SearchTheme: 'Zoek een thema (titel of tag)',
    Theme: 'Thema',
    Graduation: 'Verloop',
    Graduation_s: 'Verloop(en)',
    ErrorOccurred: 'Er is een fout opgetreden.',
    ReloadPage: 'Herlaad de pagina.',
    LoadingCategories: 'Categorieën laden',
    ShowAll: 'Alles tonen',
    Categories: 'Categorieën',
    ComingSoon: 'Binnenkort',
    DropImageHere: 'Sleep een afbeelding hierheen',
    ReleaseToImport: 'Loslaten om te importeren',
    OrClickToBrowse: 'of klik om te bladeren',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Deze drukmethode werkt met vaste kleuren. We raden vectorbestanden aan voor een optimaal resultaat.',
    SearchInPhotoGallery: 'Zoek in onze fotogalerij',
    QrCode: 'QR-code',
    QrCodeContent: 'Inhoud (URL, tekst, e-mail…)',
    QrCodePlaceholder: 'https://voorbeeld.com',
    QrCodeForeground: 'QR-kleur',
    QrCodeBackground: 'Achtergrond',
    QrCodeTransparentBg: 'Transparante achtergrond',
    QrCodeErrorLevel: 'Fouttolerantie',
    QrCodeErrorL: '7 % (lage dichtheid)',
    QrCodeErrorM: '15 % (standaard)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (hoog)',
    QrCodeEmptyPreview: 'Voer inhoud in voor een voorbeeld',
    QrCodeRequired: 'De inhoud van de QR-code is verplicht.',
    QrCodeInvalidUrl: 'Voer een geldige QR-code-URL in (http:// of https://).',
    QrCodeAdd: 'QR-code toevoegen',
    QrCodeEditOnlyColors:
        'Na het aanmaken van een QR-code kunnen alleen de kleuren worden gewijzigd. Om de inhoud te wijzigen, verwijder je hem en maak je een nieuwe aan.',
    ImageQualityGood: 'Goede resolutie',
    ImageQualityMedium: 'Gemiddelde resolutie',
    ImageQualityLow: 'Lage resolutie – vergroot de afbeelding of verklein ze op het canvas',
    LowQualityAlertTitle: 'Let op',
    LowQualityAlertMessage:
        'Je creatie bevat afbeeldingen van lage kwaliteit of die te sterk zijn vergroot ten opzichte van hun oorspronkelijke resolutie. Corrigeer je creatie of aanvaard het risico op pixelvorming bij het printen.',
    LowQualityAlertHint: 'Drempel voor lage resolutie:',
    LowQualityAcceptRisk: 'Ik aanvaard het risico op pixelvorming voor mijn afbeeldingen van lage kwaliteit',
    Preview: 'Voorbeeld',
    Bold: 'Vet',
    Italic: 'Cursief',
    Underline: 'Onderstreept',
    FontSize: 'Grootte',
    SelectFont: 'Een lettertype kiezen',
    UploadFont: 'Mijn lettertype uploaden',
    UploadFontHint: 'TTF of OTF · max. 5 MB',
    CustomFontBadge: 'eigen',
    CustomFontImported: 'Lettertype geïmporteerd.',
    CustomFontFormatError: 'Niet-ondersteund formaat (alleen TTF of OTF).',
    CustomFontTooLarge: 'Lettertype te groot (maximaal 5 MB).',
    CustomFontImportFailed: 'Importeren van lettertype mislukt.',
    CustomFontRemoved: 'Lettertype verwijderd.',
    RecentFonts: 'Recent',
    Clear: 'Wissen',
    TextColor: 'Tekstkleur',
    TextOutline: 'Omtrek',
    AddOutline: 'Een omtrek toevoegen',
    RemoveOutline: 'Omtrek verwijderen',
    PickColor: 'Een kleur kiezen',
    PickThemeCategory: 'Kies een categorie om thema\'s te verkennen',
    NoThemeInCategory: 'Geen thema in deze categorie',
    ThemePreviewLabel: 'Themavoorbeeld',
    PickAnotherTheme: 'Een ander thema kiezen',
    Keep: 'Behouden',
    LoadingThemes: 'Thema\'s laden',
    LoadingPatterns: 'Achtergronden laden',
    EditableThemeColors: 'Bewerkbare kleuren van de elementen',
    PickAColor: 'Kies een kleur',
    SelectALayout: 'Selecteer een sjabloon',
    CreateLayer: 'Een element maken',
    LastDownloads: 'Laatste downloads',
    Cancel: 'Annuleren',
    Back: 'Terug',
    BackToProvider: 'Terug naar {provider}',
    LayerNotFound: 'Het element is niet gevonden',
    ChangeImage: 'Afbeelding wijzigen',
    ChangePattern: 'Achtergrond wijzigen',
    Resize: 'Formaat wijzigen',
    RemoveBackground: 'Achtergrond verwijderen',
    Processing: 'Verwerken…',
    AddFilter: 'Een filter toevoegen',
    PhotoCredit: 'Foto van {author} op {provider}',
    PhotoBy: 'Foto van',
    On: 'op',
    LinkRedirectionWarning: 'Deze link verwijst je door naar deze website',
    LoadMore: 'Meer laden',
    EditLayer: 'Element bewerken',
    Import: 'Importeren',
    FromYourDevice: 'Van je apparaat',
    FromImageGallery: 'Uit de afbeeldingengalerij',
    NoGraduationsAvailable: 'Geen verloop beschikbaar',
    Confirm: 'Bevestigen',
    CustomizeProduct: 'Personaliseer je product',
    WriteYourText: 'Schrijf hier je tekst',
    Text: 'Tekst',
    Image: 'Afbeelding',
    DesignSummary: 'Samenvatting van je ontwerp',
    AddOptions: 'Opties toevoegen',
    TermsOfSale: 'Algemene verkoopvoorwaarden',
    TOSMessage:
        'Ik verklaar dat mijn creatie voldoet aan de [Algemene verkoopvoorwaarden](#) en in het bijzonder aan artikel 8 - Intellectueel eigendom',
    IValidateMyCreation: 'Ik bevestig mijn creatie',
    FunctionalityNotAvailable: 'Functie niet beschikbaar',
    Lock: 'Vergrendelen',
    Unlock: 'Ontgrendelen',
    AddLayer: 'Een element toevoegen',
    LayerSectionTemplates: 'Sjablonen',
    LayerSectionText: 'Tekst en gegevens',
    LayerSectionImages: 'Afbeeldingen',
    LayerSectionDecor: 'Decoratie',
    LayerSectionTools: 'Gereedschap',
    DragLayersToReorder: 'Sleep de lagen om ze te herordenen',
    PleaseAgreeTOS: 'Aanvaard de algemene voorwaarden om je creatie te bevestigen.',
    ErrorExportPrintFile: 'Er is een fout opgetreden bij het exporteren van het drukbestand.',
    ErrorExportProofFile: 'Er is een fout opgetreden bij het exporteren van de drukproef.',
    ErrorAddToCart: 'Er is een fout opgetreden bij het toevoegen aan de winkelwagen: ',
    Gabarit: 'Sjabloon',
    FicheTechnique: 'Technische fiche',
    GeneratingPrintFile: 'Drukbestand genereren…',
    GeneratingProofFile: 'Drukproef genereren…',
    LeaveCustomizer: 'Configurator verlaten',
    LeaveManager: 'Elementbeheer verlaten',
    ChangeProductTitle: 'Je creatie wordt gewist.',
    ChangeProductConfirm: 'Van product wisselen wist je creatie definitief, weet je het zeker?',
    Duplicate: 'Dupliceren',
    LoadingTheme: 'Thema laden',
    LoadingPattern: 'Achtergrond laden',
    Expand: 'Vergroten',
    Shrink: 'Verkleinen',
    TiltLeft: 'Naar links kantelen',
    TiltRight: 'Naar rechts kantelen',
    Rotate: 'Draaien',
    Move: 'Verplaatsen',
    Reposition: 'Herpositioneren',
    MoveUp: 'Naar boven verplaatsen',
    MoveDown: 'Naar beneden verplaatsen',
    MoveLeft: 'Naar links verplaatsen',
    MoveRight: 'Naar rechts verplaatsen',
    NoCustomization: 'Er is geen personalisatie op het product.',
    MissingCustomization: 'Ontbrekende personalisatie',
    SelectGraduation: 'Selecteer een verloop',
    ProofTitle: 'Drukproef',
    ProofDesignTitle: '2D-personalisatie',
    ProofScreenshotsTitle: '3D-weergaven',
    ProofSelectedInksTitle: 'Geselecteerde kleuren',
    Warning: 'Let op',
    SelectZoneBeforeTheme: 'Selecteer een zone voordat je een thema kiest.',
    ThemeTooManyElements: 'Het thema bevat te veel elementen. Kies een ander',
    Error: 'Fout',
    ProductNotFound: 'Product niet gevonden',
    ProductNotFoundMessage: 'Product niet gevonden, je wordt doorgestuurd naar de startpagina.',
    NoCategoryAvailable: 'Geen categorie beschikbaar',
    CategoryNotFound: 'Categorie niet gevonden',
    CategoryNotFoundMessage: 'Categorie niet gevonden, je wordt doorgestuurd naar de startpagina.',
    Unavailable: 'Niet beschikbaar',
    SavedConfigurations: 'Opgeslagen configuraties',
    YourSavedConfigurations: 'Je opgeslagen configuraties',
    NoSavedConfigurations: 'Geen opgeslagen configuratie voor dit product',
    ConfigurationName: 'Naam van de configuratie',
    Created: 'Aangemaakt',
    Expires: 'Verloopt',
    Load: 'Laden',
    ConfirmDeleteConfiguration: 'Weet je zeker dat je deze configuratie wilt verwijderen?',
    Close: 'Sluiten',
    Step: 'Stap',
    CustomizeProductDesc: 'Kies hoe je begint: vrij ontwerpen of vanaf een hieronder voorgesteld thema.',
    StartFromScratchDesc: 'Een leeg canvas om teksten, afbeeldingen en vormen toe te voegen, zonder opgelegd sjabloon.',
    ChooseProductDesc: 'Kies een product om te personaliseren.',
    PrintMethod: 'Drukmethode',
    ChoosePrintMethod: 'Kies je methode',
    ChoosePrintMethodDesc:
        'Selecteer de drukmethode voor dit product. Deze keuze is definitief voor deze personalisatie.',
    Digital: 'Digitaal',
    ScreenPrinting: 'Zeefdruk',
    LaserEngraving: 'Lasergravure',
    Embroidery: 'Borduren',
    RestrictedToPalette: 'Kleuren beperkt tot het palet',
    ChooseInks: 'Kies je inkten',
    ChooseThreads: 'Kies je draden',
    AppliesToZone: 'Zone: {zone}',
    Ink: 'Inkt',
    Thread: 'Draad',
    InkOverride: 'Een inkt forceren',
    ThreadOverride: 'Een draad forceren',
    SuggestInks: 'Voorgestelde inkten',
    SuggestThreads: 'Voorgestelde draden',
    RecommendColorsFromImage: 'Kleuren aanbevelen op basis van de afbeelding',
    NoColorSuggestion: 'Geen kleursuggestie voor deze afbeelding.',
    InkAssistantHelp: 'Deze methode gebruikt een palet van {count} vaste kleuren.',
    InkAssistantQuestion: 'Hoe wil je je kleuren bepalen?',
    InkAssistantUpload: 'Help me mijn kleuren te vinden',
    InkAssistantUploadDesc:
        'Importeer je afbeelding, logo of motief – we detecteren automatisch de dichtstbijzijnde paletkleuren.',
    InkAssistantManual: 'Ik kies mijn kleuren handmatig',
    InkAssistantManualDesc: 'Selecteer elke kleur één voor één in het palet.',
    InkAssistantAnalyzing: 'Je afbeelding analyseren…',
    InkChoiceModifiableHint: 'Deze keuze kan op elk moment worden gewijzigd.',
    InkAssistantResultDesc: 'Dit zijn de paletkleuren die het dichtst bij je afbeelding liggen.',
    InkDuplicateWarning:
        'Deze kleur is al geselecteerd voor een andere inkt / draad. Een tweede keer selecteren voegt de kleuren definitief samen. Weet je het zeker?',
    Selected: 'Geselecteerd',
    VectorizeImage: 'Afbeelding vectoriseren',
    Vectorizing: 'Vectoriseren…',
    VectorizePreviewTitle: 'Resultaat van de vectorisatie',
    VectorizeIntro:
        'De afbeelding wordt omgezet naar een vector en beperkt tot de gekozen inkten. Bevestig het resultaat om het toe te passen.',
    VectorizeApply: 'Vector toepassen',
    VectorizeConsent:
        'Ik begrijp dat ik verantwoordelijk ben voor de controle van het vectorisatieresultaat en dat de druk hiervan een weergave zal zijn.',
    VectorizeThreshold: 'Drempel (detail / achtergrond)',
    VectorizeThresholdHint:
        'Pas de drempel aan om te verfijnen: lager verwijdert meer lichte achtergrond (line-art); hoger behoudt meer lichte zones.',
    VectorizeCancel: 'Annuleren',
    VectorizeFailed: 'De vectorisatie is mislukt. Probeer opnieuw of kies een andere afbeelding.',
    Before: 'Voor',
    After: 'Na',
    VariableText: 'Variabele tekst',
    VariableTextIntro:
        'Deze functie lijkt op een mailing en levert je product in één uniek exemplaar per tekst; het aantal wordt automatisch berekend voor je winkelwagen.',
    VariableTextData: 'Gegevens (één regel = één exemplaar)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Een CSV / Excel importeren',
    SessionImages: 'Geïmporteerde afbeeldingen',
    Accept: 'Accepteren',
    UploadConsentMessage:
        'Ik bevestig dat geen van mijn bestanden de geldende wetten, auteursrechten of rechten van derden schendt.',
    VariableTextNoData: 'Voeg minstens één regel toe voor een voorbeeld.',
    VdpFields: 'Variabele velden',
    VdpFieldName: 'Veldnaam',
    VdpPlace: 'Plaatsen',
    VdpPlaced: 'Geplaatst',
    VdpAddField: 'Een veld toevoegen',
    VdpAddRow: 'Een regel toevoegen',
    VdpLine: 'Rij',
    VdpEnterData: 'Mijn gegevens invoeren',
    Done: 'Klaar',
    VdpFieldStyle: 'Veldstijl',
    VdpFirstRowHeader: '1e regel = koptekst (veldnamen)',
    VdpQuantity: 'Aantal: {qty}',
    VdpQuantityHint: 'Het aantal wordt bepaald door het aantal regels van je variabele tekst.',
    VariableTextOnlyOne: 'Slechts één veld voor variabele tekst per creatie.',
    VariableTextEmptyFile: 'Leeg bestand of zonder bruikbare kolom.',
    VariableTextImportError: 'Dit bestand kan niet worden gelezen. Gebruik een CSV of plak de tekst.',
    VariableTextExcelUnavailable: 'Excel lezen niet beschikbaar. Exporteer naar CSV of plak de tekst.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks: 'Geselecteerde inkten: {chosen}/{required}. Kies alle inkten voordat je bevestigt.',
    PreflightScreenColorCount: 'Zeefdruk: je creatie is beperkt tot {count} inkt(en).',
    PreflightMinStroke: 'Aanbevolen minimale lijndikte: {mm} mm. Dunnere lijnen kunnen slecht printen.',
    PreflightMinFont: 'Aanbevolen minimale lettergrootte: {pt} pt.',
    PreflightLaserMonochrome: 'Lasergravure: het eindresultaat is monochroom.',
    More: 'Meer',
    All: 'Alle',
    AllCategories: 'Alle categorieën',
    SearchCategory: 'Een categorie zoeken…',
    NoProductAvailable: 'Geen product in deze categorie.',
    ChooseProductTitle: 'Kies je product om te personaliseren',
    PrintMethodQuestion: 'Hoe wil je je {product} bedrukken?',
    PrintMethodIntro:
        'Elke methode heeft haar sterke punten en beperkingen — ze bepaalt de daarna beschikbare kleuren en afwerkingen.',
    StartLabel: 'Startpunt',
    StartTitle: 'Begin met een thema of een blanco pagina',
    StartIntro:
        'Een thema = een kant-en-klaar ontwerp om aan te passen (het snelst). Blanco pagina = volledige controle.',
    StepProduct: 'Product',
    StepMethod: 'Methode',
    StepStart: 'Start',
    StepDesign: 'Ontwerp',
    ChangeTheme: 'Thema wijzigen',
    BackToTheme: 'Terug naar thema',
    Recent: 'Recent',
    WhiteNotPrintable: 'Wit kan niet worden gedrukt (transparant).',
    LoginToSave: 'Log in om je ontwerpen terug te vinden in je account.',
    Login: 'Inloggen',
    LoggingIn: 'Bezig met inloggen…',
    ContinueWithoutAccount: 'Doorgaan zonder account',
    SaveEmailPlaceholder: 'Je e-mailadres',
    SaveEmailHint: 'Je ontvangt een link om je project te hervatten (30 dagen bewaard).',
    SaveConfirmTitle: 'Project opgeslagen',
    SaveConfirmMessage: 'Je project is opgeslagen. We hebben je zojuist een e-mail met de hervattingslink gestuurd.',
    DisableEmbroideryEffect: 'Borduureffect uitschakelen',
    AddThread: 'Draad toevoegen',
    RemoveThread: 'Draad verwijderen',
    VectorizeDenoise: 'Ruis verminderen',
    VectorizeDenoiseHint: 'Verwijdert vlekjes en kleine stofjes.',
    VectorizeSmoothing: 'Verzachten',
    VectorizeSmoothingHint: 'Rondt de contouren af (minder hoeken).',
    ZoomIn: 'Inzoomen',
    ZoomOut: 'Uitzoomen',
    Fit: 'Passend maken',
    Apply: 'Toepassen',
    Edit: 'Bewerken',
    Support: 'Ondersteuning',
    VectorizeAcknowledge:
        'Ik begrijp dat ik verantwoordelijk ben voor het controleren van het vectorisatieresultaat en dat de druk dit weergeeft.',
    Crop: 'Bijsnijden',
    Font: 'Lettertype',
    Style: 'Stijl',
    Outline: 'Omtrek',
    Steps: 'Stappen',
    Tools: 'Gereedschap',
    ThemeColors: 'Kleuren',
    Minimize: 'Minimaliseren',
    MoveLayerUp: 'Laag omhoog',
    MoveLayerDown: 'Laag omlaag',
    DragLayer: 'Sleep om te herschikken',
    NoResult: 'Geen resultaat',
    SearchElement: 'Zoek een element…',
    ExpertMode: 'Expertmodus',
    Finish: 'Voltooien',
    ChooseImageOrPhoto: 'Kies een afbeelding of foto',
    WizardIntro: 'Volg de stappen voor een gepersonaliseerd ontwerp in 1 minuut.',
    WizardIntroExpert: 'Wil je meer vrijheid? Schakel over naar de expertmodus.',
    ClickToChooseImage: 'Klik hier om een afbeelding of foto te kiezen',
    ChooseCategoryDesc: 'Kies een productfamilie om te beginnen.',
    SelectProductDesc: 'Kies een product om te beginnen…',
    FinalReview: 'Laatste stap',
    StartWithThemeDesc: 'Begin met een vooraf ingesteld ontwerp.',
    WithModelDesc: 'Kies een kant-en-klaar sjabloon.',
    ExpertModeConfirmTitle: 'Expertmodus',
    ExpertModeConfirmMsg:
        'Overschakelen naar de expertmodus is een definitieve keuze. Deze modus is iets complexer in gebruik, maar laat je elementen zonder beperkingen toevoegen en bewerken.',
    ExpertModeHint: 'Maak je ontwerp zonder grenzen af – voeg tekst en foto\'s toe zoals je wilt.',
    VariableData: 'Variabele gegevens',
    PhotoFrame: 'Fotolijst',
    PhotoFrameHint: 'Kies een vorm en plaats er daarna een foto in.',
    PhotoFrameChooseShape: '1. Vorm van de lijst',
    PhotoFrameChangeShape: 'Vorm wijzigen',
    PhotoFramePickPhoto: 'Kies een foto',
    FromLibrary: 'Uit de bibliotheek',
    VdpMaxRowsReached: 'Maximale voorraad bereikt',
    VdpImportTruncated: 'Import beperkt tot beschikbare voorraad',
    LetterSpacing: 'Letterafstand',
    OutlineActive: 'Contour ingeschakeld',
    OutlineThickness: 'Contourdikte',
    AlignLeft: 'Links uitlijnen',
    AlignCenter: 'Centreren',
    AlignRight: 'Rechts uitlijnen',
    Uppercase: 'Hoofdletters',
    TextFormatting: 'Opmaak',
    FontSizeLabel: 'Tekengrootte',
    SelectionActions: 'Selectieacties',
    DragToMove: 'Sleep om te verplaatsen',
    DragToResize: 'Sleep om te vergroten of verkleinen',
    DragToRotate: 'Sleep om te draaien',
    MoveUpOneLevel: 'Eén niveau omhoog',
    MoveDownOneLevel: 'Eén niveau omlaag',
    BringToFront: 'Naar voorgrond',
    Front: 'Voorgrond',
    SendToBack: 'Naar achtergrond',
    BackgroundNeverUnderPattern: 'Achtergrond (nooit onder een achtergrondpatroon)',
    EyedropperColor: 'Kleurenpipet',
    PresetColors: 'Vooraf ingestelde kleuren',
    RecentColors: 'Recente kleuren',
    Palette: 'Palet',
    HexValue: 'Hex-waarde',
    AiResultsHint: 'Vind alle suggesties op het tabblad Afbeelding',
    Notifications: 'Meldingen',
    Zoom: 'Zoom',
    GuidedCustomization: 'Begeleide personalisatie',
    Actions: 'Acties',
    InkAssistantYourChoice: 'Je hebt gekozen:',
    InkAssistantCorrectQuestion: 'Wil je deze keuze wijzigen?',
    ZonePrices: 'Prijs per zone',
    ZonePriceApplied: 'Toegepast',
    ZonePriceUncovered: 'Geen enkele optie dekt alle ontworpen zones.',
    ZonePricesShow: 'Tonen',
    ZonePricesHide: 'Verbergen',
    '': ''
};
